import apiClient from '../client';
import type { DocumentRecord, CreateDocumentPayload } from '@/types';

const BASE = '/admin/documents';

export const documentsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: DocumentRecord[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: DocumentRecord }>(`${BASE}/${id}`).then((r) => r.data.data),

  issue: (payload: CreateDocumentPayload) =>
    apiClient.post<{ data: DocumentRecord }>(BASE, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),
};

